import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import ForgotPassword from "../components/ForgotPassword";
import { ApplicationState } from "../../redux/ApplicationState";
import { sendForgotPasswordLink } from "../../actions/UserAction";
import { SendLink } from "../../models/User";

const mapStateToProps = ({ forgotLinkState }: ApplicationState) => ({
  forgotLinkState: forgotLinkState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    sendForgotPasswordLink: (payload: SendLink) => {
      dispatch(sendForgotPasswordLink(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
